import {
  IconCalendarTime,
  IconChevronLeft,
  IconChevronRight,
  IconListDetails,
  IconPrinter,
  IconReload,
  IconSearch,
  IconCloudDownload,
  IconTrash,
} from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultItem from '../components/Admin/DefaultItem';
import { getAuthorizationHeader, http } from '../config/http';
import Layouts from '../layouts/Layouts';
import InputBarang from '../components/Admin/InputBarang';
import DetailItem from './Modal/DetailItem';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import PrintBandrol from '../components/Admin/PrintBandrol';
import { DinamicTitle } from '../utils/DinamicTitle';
import EditItem from './Modal/EditItem';
import Input from '../components/Input';
import ConfirmationDeleteItem from '../components/Admin/ConfirmationDeleteItem';
import { toast } from 'react-toastify';
import useKarat from './features/useKarat';
import usePage from './features/usePage';
import { IconTransferIn, IconBookDownload, IconTransferOut } from '@tabler/icons-react';
import TransferBanyakBarang from '../components/Admin/PindahBarangBanyak';
import HapusBanyakBarang from '../components/Admin/HapusBanyakBarang';
import TransferBarangToCabang from '../components/Admin/TransferBarangToCabang';
import useCabang from './features/useCabang';
import LoadingIndicator from '../components/LoadingIndicator';

function ListItemAdmin() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  // console.log('items::: ', items);
  const [kategori, setKategori] = useState([]);
  const [page_filter, setPageFilter] = useState([]);

  const [selectedKategori, setSelectedKategori] = useState('');
  const [bakiId, setBakiId] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const [totalModal, setTotalModal] = useState(0);
  const [jmlBarang, setJmlBarang] = useState(0);
  const [jmlBerat, setJmlBerat] = useState(0);
  // const [cabang, setCabang] = useState([]);
  const { cabang } = useCabang();

  const [isSubmitItem, setIsSubmitItem] = useState(false);

  const [detailItem, setDetailItem] = useState([]);
  // console.log('detailItem::: ', detailItem);
  const [openLoading, setOpenLoading] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  //   const [openCalender, setOpenCalender] = useState(false);

  let [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(0);
  const [selectStatus, setSelectStatus] = useState('');
  const [selectCabang, setSelectCabang] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [openPrintBandrol, setOpenPrintBandrol] = useState(false);
  const [openPindahBanyakBarang, setOpenPindahBanyakBarang] = useState(false);
  const [openHapusBanyakBarang, setOpenHapusBanyakBarang] = useState(false);
  const [openPindahBanyakBaki, setOpenPindahBanyakBaki] = useState(false);
  const [totalModalFilter, setTotalModalFilter] = useState(0);
  const [isEdit, setIsEdit] = useState(false);

  const [deleteId, setDeleteId] = useState('');
  const [barangDelete, setBarangDelete] = useState([]);
  const [loadingDel, setLoadingDel] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  // const [page_filter_loop, setPageFilterLoop] = useState([]);
  const [filterBerat, setFilterBerat] = useState('');

  const [berat, setBerat] = useState('');

  const filterBeratBarang = () => {
    setBerat(filterBerat);
  };

  function refreshPage() {
    window.location.reload(false);
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };
  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // useEffect(() => {
  //   async function getCabangSelect() {
  //     await http
  //       .get(`cabang`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setCabang(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getCabangSelect();
  // }, [navigate]);

  async function getKategori() {
    await http
      .get('/kategori', {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setKategori(res.data);
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      });
  }
  useEffect(() => {
    getKategori();
  }, [navigate]);

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
  };

  const [search, setSearch] = useState('');

  async function getItems() {
    const page = `?page=${currentPage}`;
    // const page = (currentPage && page_filter !== '') ? `?page=${page_filter}` : `?page=${currentPage}`;
    setLoading(true);
    await http
      .get(
        `/item${search === '' ? page : `?kode=${search}`}${selectedKategori === '' ? `` : `&kategori=${selectedKategori}`}${selectJenisKategori === '' ? `` : `&jenis_kategori=${selectJenisKategori}`
        }${selectStatus === '' ? `` : `&status=${selectStatus}`}${selectCabang === '' ? `` : `&cabang=${selectCabang}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${bakiId === '' ? '' : `&no_baki=${bakiId}`}${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${berat === '' ? '' : `&berat=${berat}`}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setItems(res.data.data.data);
        setTotalModal(res.data.total_modal);
        setTotalModalFilter(res.data.total_modal_filter);
        setJmlBarang(res.data.data.total);
        setJmlBerat(res.data.total_berat_page);
        setPage(res.data.data.last_page);
        // setPageFilterLoop(res.data.last_page);
        setItemsPerPage(res.data.data.per_page);
        setCurrentPage(res.data.data.current_page);
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      });
    setLoading(false);
  }
  useEffect(() => {
    getItems();
  }, [
    selectedKategori,
    bakiId,
    isDelete,
    search.length >= 10 ? search : '',
    selectJenisKategori,
    isEdit,
    currentPage,
    selectStatus,
    selectCabang,
    awal,
    akhir,
    isSubmitItem,
    karatOptionId,
    berat,
    page_filter
  ]);
  function closeModal() {
    setIsOpen(false);
  }
  function closeModalDetail() {
    setOpenDetail(false);
  }

  function openModal() {
    setIsOpen(true);
    // console.log('hallo');
  }
  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }

  const { pageOption, pageOptionId, setPageOptionId } = usePage();

  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [isCheckedItems, setIsCheckedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectPindahItems, setSelectPindahItems] = useState([]);

  const resetSelectPindahItems = () => {
    setSelectPindahItems([]); // Mengosongkan array
  };

  // console.log(selectPindahItems);
  // SELECT CHECKBOX
  function handleCheckboxChange(event, item) {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, item]);
      setSelectPindahItems([...selectPindahItems, item]);
    } else {
      setSelectedItems(selectedItems.filter((selectedItem) => selectedItem !== item));
      setSelectPindahItems(selectPindahItems.filter((selectedItem) => selectedItem !== item));
    }
  }

  function handleCheckAll(event) {
    setIsCheckedAll(event.target.checked);
    setIsCheckedItems(isCheckedItems.map(() => event.target.checked));
    setSelectedItems([...items]);
    setSelectPindahItems([...items]);
    if (event.target.checked === false) {
      setSelectedItems([]);
      setSelectPindahItems([]);
    }
  }
  // END SELECT CHECKBOX
  function closeModalPrintBandrol() {
    setOpenPrintBandrol(false);
  }
  function closeModalPindahBarangBanyak() {
    setOpenPindahBanyakBarang(false);
  }
  function openModalPindahBarangBanyak() {
    setOpenPindahBanyakBarang(true);
  }
  function openModalPrintBandrol() {
    setOpenPrintBandrol(true);
  }


  //ini untuk hapus banyak barang
  //start
  function closeModalHapusBarangBanyak() {
    setOpenHapusBanyakBarang(false);
  }
  function openModalHapusBarangBanyak() {
    setOpenHapusBanyakBarang(true);
  }
  //end


  //ini untuk pindah banyak baki
  //start
  function closeModalPindahBarangBaki() {
    setOpenPindahBanyakBaki(false);
  }
  function openModalPindahBarangBaki() {
    setOpenPindahBanyakBaki(true);
  }
  //end


  function setPageFilterCurrent(val) {
    setCurrentPage(val);
    setPageFilter(val)
  }

  function nextPage() {
    setCurrentPage(currentPage + 1);
    setSelectedItems([]);
    setIsCheckedAll(false);
    // setPageFilter([]);
  }

  function prevPage() {
    setCurrentPage(currentPage - 1);
    setSelectedItems([]);
    setIsCheckedAll(false);
    // setPageFilter([]);
  }
  DinamicTitle('List Barang || Komaladewi');

  let [isOpenEditItem, setIsOpenEditItem] = useState(false);

  function closeModalEditItem() {
    setIsOpenEditItem(false);
  }

  function openModalEditItem() {
    setIsOpenEditItem(true);
  }

  async function getItemEdit(id) {
    setOpenLoading(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        openModalEditItem();
      });
    setOpenLoading(false);
  }

  const [filterBaki, setFilterBaki] = useState([]);

  useEffect(() => {
    const numbersArray = [];
    for (let i = 1; i <= 20; i++) {
      numbersArray.push(i);
    }
    setFilterBaki(numbersArray);
  }, []);

  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;

  async function showDetailItem(id) {
    setOpenLoading(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        setOpenDetail(true);
      });
    setOpenLoading(false);
  }

  let [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  let [isOpenModalPindah, setIsOpenModalPindah] = useState(false);
  const [loadingPin, setLoadingPin] = useState(false);


  function closeModaDelete() {
    setIsOpenModalDelete(false);
  }

  function openModalDelete() {
    setIsOpenModalDelete(true);
  }

  function closeModaPindah() {
    setIsOpenModalPindah(false);
  }

  function openModalPindah() {
    setIsOpenModalPindah(true);
  }

  async function getIdPindahItem(id) {
    setLoadingPin(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        openModalPindah();
        setLoadingPin(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getIdDelete(id) {
    setLoadingDel(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        openModalDelete();
        setDeleteId(res.data.data.id);
        setBarangDelete(res.data.data);
        setLoadingDel(false);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingDel(false);
  }
  const [keterangan, setKeterangan] = useState('')
  async function deleteBarang(e) {
    e.preventDefault();
    setIsDelete(true);
    await http
      .post(`item/hapus`, {
        item_id: deleteId,
        keterangan: keterangan
      }, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        closeModaDelete();
        toast.success(res.data.message, { autoClose: 600, });
        // console.log(res)
      })
      .catch((err) => {
        console.log(err);
      });
    setIsDelete(false);
  }

  const user = localStorage.getItem('role');
  const [openModalTransferToToko, setOpenModalTransferToToko] = useState(false)
  function closeOpenModalTransferToToko() {
    setOpenModalTransferToToko(false);
  }
  function reloadDate() {
    getItems();
  }

  return (
    <Layouts
      title={'List Barang'}
      dateFilter={`${awal === 'Invalid date' ? '' : ` ${awal}`} ${awal == akhir ? `` : `${akhir === 'Invalid date' ? '' : ` s/d ${akhir}`}`}`}
      compFilter={
        <div className="flex items-center gap-1.5">
          <button
            onClick={() => setOpenModalTransferToToko(true)}
            className="px-3 py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-lg text-sm font-medium shadow-sm hover:shadow transition-all duration-200 flex items-center gap-1.5"
          >
            <IconTransferIn size={18} />
            Transfer
          </button>
          <div className="dropdown dropdown-bottom">
            <div
              tabIndex={0}
              className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
            >
              <IconCalendarTime size={20} />
            </div>
            <div tabIndex={0} className="dropdown-content menu -right-52 p-2 z-50">
              <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
            </div>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
          >
            <IconReload size={20} />
          </button>
          <div className="relative">
            <IconSearch size={16} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" />
            <Input
              onChange={(e) => setSearch(e.target.value)}
              className="input input-bordered rounded-lg pl-8 pr-3 py-2 bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 text-sm transition-all"
              autoComplete="off"
              type="search"
              name="search"
              placeholder="Cari Kode Barang"
            />
          </div>
        </div>
      }
      openModal={openModal}
    >
      <ConfirmationDeleteItem
        reloadDate={reloadDate}
        isDelete={isDelete}
        deleteBarang={deleteBarang}
        setKeterangan={setKeterangan}
        barangDelete={barangDelete}
        isOpenModalDelete={isOpenModalDelete}
        closeModaDelete={closeModaDelete}
      />
      <InputBarang
        setIsSubmitItem={() => setIsSubmitItem(true)}
        closeModal={closeModal}
        isOpen={isOpen}
        kategori={kategori}
      />
      <EditItem
        setIsEdit={setIsEdit}
        kategori={kategori}
        cabang={cabang}
        detailItem={detailItem}
        isOpenEditItem={isOpenEditItem}
        closeModalEditItem={closeModalEditItem}
      />
      <DetailItem
        checkBerat={checkBerat}
        detailItem={detailItem}
        closeModalDetail={closeModalDetail}
        openDetail={openDetail}
      />
      {openLoading || loadingDel || loadingPin ? (
        <LoadingIndicator />
      ) : (
        ''
      )}

      {/* ═══ Filter Bar ═══ */}
      <div className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-b border-amber-100/60 dark:border-slate-700/60 px-3 py-2.5 transition-colors">
        <div className="flex items-center gap-2 w-full overflow-x-auto scrollbar-none">
          <div className="flex items-center gap-1.5 flex-shrink-0">
            {/* Kategori */}
            <select
              value={selectedKategori}
              onChange={handleKategoriChange}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Kategori</option>
              {kategori.map((kt) => (
                <option key={kt.id} value={kt.id}>
                  {kt.nama_kategori}
                </option>
              ))}
            </select>

            {/* Jenis Kategori */}
            {selectedKategori && (
              <select
                onChange={handleJenisKategoriChange}
                value={selectJenisKategori}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">Jenis Kategori</option>
                {kategori
                  .find((kt) => kt.id == selectedKategori)
                  ?.jenis_kategori.map((jk) => (
                    <option key={jk.id} value={jk.id}>
                      {jk.nama_jenis}
                    </option>
                  ))}
              </select>
            )}

            {/* Status */}
            <select
              onChange={(e) => setSelectStatus(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Status</option>
              <option value={1}>Tersedia</option>
              <option value={0}>Tidak Tersedia</option>
            </select>

            {/* Baki */}
            <select
              onChange={(e) => setBakiId(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Baki</option>
              {filterBaki.map((ftb) => (
                <option value={ftb} key={ftb}>{ftb}</option>
              ))}
            </select>

            {/* Etalase */}
            <select
              onChange={(e) => setSelectCabang(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Etalase</option>
              {cabang.map((cb) => (
                <option key={cb.id} value={cb.id}>{cb.nama_cabang}</option>
              ))}
            </select>

            {/* Karat */}
            <select
              onChange={(e) => setKaratOptionId(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Karat</option>
              {karatOption.map((kto) => (
                <option value={kto} key={kto}>{kto}</option>
              ))}
            </select>

            {/* Berat Search */}
            <div className="flex items-center gap-1 w-44">
              <Input
                onChange={(e) => setFilterBerat(e.target.value)}
                placeholder="Cari Berat"
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none w-full"
              />
              <button
                onClick={filterBeratBarang}
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 p-2 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 flex-shrink-0"
              >
                <IconSearch size={18} />
              </button>
            </div>
          </div>

          {/* Action Buttons (right aligned) */}
          <div className="flex items-center gap-1.5 ml-auto flex-shrink-0">
            {user !== 'admin' && (
              <>
                <button
                  onClick={openModalPindahBarangBanyak}
                  className="bg-blue-500 hover:bg-blue-600 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
                  title="Pindah Barang"
                >
                  <IconTransferOut size={18} />
                </button>
                <button
                  onClick={openModalHapusBarangBanyak}
                  className="bg-red-500 hover:bg-red-600 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
                  title="Hapus Barang"
                >
                  <IconTrash size={18} />
                </button>
              </>
            )}
            <button
              onClick={reloadDate}
              className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
              title="Reload"
            >
              <IconReload size={18} />
            </button>
            <button
              onClick={openModalPrintBandrol}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
              title="Print Bandrol"
            >
              <IconPrinter size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* ═══ Modals for bulk actions ═══ */}
      <div>
        <PrintBandrol
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          openPrintBandrol={openPrintBandrol}
          closeModalPrintBandrol={closeModalPrintBandrol}
        />
        <TransferBarangToCabang
          openPindahBarangBanyak={openModalTransferToToko}
          setOpenPindahBanyakBarang={setOpenModalTransferToToko}
          reloadDate={reloadDate}
          closeModalBanyakBarang={closeOpenModalTransferToToko}
          selectedItems={selectPindahItems}
          refreshPage={refreshPage}
          setSelectedItems={setSelectPindahItems}
          resetSelectPindahItems={resetSelectPindahItems}
        />
        <TransferBanyakBarang
          cabang={cabang}
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openPindahBarangBanyak={openPindahBanyakBarang}
          setOpenPindahBanyakBarang={setOpenPindahBanyakBarang}
          closeModalBanyakBarang={closeModalPindahBarangBanyak}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        <HapusBanyakBarang
          cabang={cabang}
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openHapusBarangBanyak={openHapusBanyakBarang}
          setOpenHapusBanyakBarang={setOpenHapusBanyakBarang}
          closeModalBanyakBarang={closeModalHapusBarangBanyak}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        {/* ═══ Loading State ═══ */}
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="flex flex-col items-center gap-3">
              <div className="w-10 h-10 border-3 border-amber-200 dark:border-amber-800 border-t-amber-500 dark:border-t-amber-400 rounded-full animate-spin"></div>
              <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
            </div>
          </div>
        ) : (
          /* ═══ Data Table ═══ */
          <div className="relative overflow-x-auto overflow-hidden mx-3 mt-3 mb-16 rounded-xl border border-slate-200/60 dark:border-slate-700/60 shadow-sm">
            <table className="w-full text-sm text-left dark:text-slate-300">
              <thead className="sticky top-0 z-10">
                <tr className="bg-gradient-to-r from-amber-50 to-amber-100/70 dark:from-slate-800 dark:to-slate-800/70 border-b border-amber-200/50 dark:border-slate-700">
                  <th scope="col" className="px-3 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    No
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Kode Barang
                  </th>
                  <th scope="col" className="px-4 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Nama Barang
                  </th>
                  <th scope="col" className="px-4 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Baki
                  </th>
                  <th scope="col" className="px-4 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Berat | Karat
                  </th>
                  <th scope="col" className="px-4 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Lokasi
                  </th>
                  <th scope="col" className="px-4 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Tanggal
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                    Aksi
                  </th>
                  <th scope="col" className="px-2 py-3.5">
                    <input
                      type="checkbox"
                      checked={isCheckedAll}
                      onChange={handleCheckAll}
                      className="cursor-pointer checkbox checkbox-warning w-4 h-4 border-amber-400 rounded"
                    />
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700 bg-white dark:bg-slate-900">
                <DefaultItem
                  cabang={cabang}
                  currentPage={currentPage}
                  setSelectedItems={setSelectedItems}
                  startIndex={startIndex}
                  getIdDelete={getIdDelete}
                  getIdPindahItem={getIdPindahItem}
                  page={page}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedItems={selectedItems}
                  checkBerat={checkBerat}
                  showDetailItem={showDetailItem}
                  openModalEditItem={openModalEditItem}
                  getItemEdit={getItemEdit}
                  items={items}
                  search={search}
                  isCheckedItems={isCheckedItems}
                />
              </tbody>
            </table>
          </div>
        )}

        {/* ═══ Footer: Summary + Pagination ═══ */}
        <div className="bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm bottom-0 left-0 py-2.5 px-4 w-full absolute border-t border-amber-100/60 dark:border-slate-700/60 transition-colors">
          <div className="flex items-center justify-between">

            {/* Desktop Summary */}
            <div className="lg:flex hidden items-center gap-5">
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Modal</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">
                  Rp {numberWithCommas(totalModal == totalModalFilter ? totalModal : totalModalFilter)}
                </span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Barang</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBarang}</span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Berat</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBerat} gr</span>
              </div>
            </div>

            {/* Mobile Summary */}
            <div className="dropdown dropdown-top lg:hidden">
              <div
                tabIndex={0}
                className="bg-gradient-to-r from-amber-500 to-amber-600 cursor-pointer hover:from-amber-600 hover:to-amber-700 hover:shadow-md p-2 text-white rounded-lg shadow-sm transition-all duration-200"
              >
                <IconListDetails size={20} />
              </div>
              <div tabIndex={0} className="dropdown-content menu p-4 shadow-xl bg-white dark:bg-slate-800 rounded-xl w-[320px] border border-amber-100 dark:border-slate-700">
                <div className="space-y-3">
                  <div className="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Modal</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">
                      Rp {numberWithCommas(totalModal == totalModalFilter ? totalModal : totalModalFilter)}
                    </span>
                  </div>
                  <div className="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Barang</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBarang} barang</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Berat</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBerat} gram</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Pagination */}
            <div className="flex items-center gap-2.5">
              <span className="text-xs font-medium text-slate-500 dark:text-slate-400">
                Halaman <span className="font-bold text-amber-700 dark:text-amber-400">{currentPage}</span> dari <span className="font-bold text-amber-700 dark:text-amber-400">{page}</span>
              </span>
              <div className="flex items-center gap-1">
                <button
                  onClick={prevPage}
                  disabled={currentPage < 2}
                  title="previous"
                  type="button"
                  className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <IconChevronLeft size={16} />
                </button>
                <button
                  onClick={nextPage}
                  disabled={currentPage >= page}
                  title="next"
                  type="button"
                  className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <IconChevronRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default ListItemAdmin;
